import styled from 'styled-components'

export const TableWrapper = styled.div`
  overflow-x: auto;
`

export const PriceTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  td {
    padding: 6px 10px;
    text-align: center;
    border: 1px solid #ddd;
    vertical-align: middle;
  }
`

export const FixedTh = styled.th`
  background-color: ${props => props.theme?.firstColor} !important;
  color: white !important;
  padding: 6px 10px;
  border: 1px solid #ddd;
  text-align: center;
  font-weight: 600;
  white-space: nowrap;
`

export const EstimateTh = styled.th`
  background-color: ${props => props.theme?.firstColor} !important;
  color: white !important;
  padding: 6px 10px;
  border: 1px solid #ddd;
  text-align: center;
  font-weight: 600;
  white-space: nowrap;
`

export const LeftHeaderTh = styled.th`
  background-color: ${props => props.theme?.firstColor} !important;
  color: white !important;
  padding: 6px 10px;
  border: 1px solid #ddd;
  text-align: left;
  font-weight: 600;
  vertical-align: middle;
  min-width: 120px;
`

export const GroupCell = styled.td`
  background-color: #f0f0f0;
  writing-mode: sideways-lr;
  font-weight: 600;
  font-size: 12px;
  vertical-align: middle !important;
`

export const LabelCell = styled.td`
  text-align: left !important;
  white-space: nowrap;
  background-color: #fafafa;
`
